export default __webpack_public_path__ + "static/media/ic_medium-1.f3c18e6f.svg";